import { GButton, GDialog } from 'components/basic-blocks'

// DEV-2353 — Google Ads "Managers" screen, where the client accepts our MCC link request.
export const GOOGLE_ADS_MANAGERS_URL = 'https://ads.google.com/aw/accountaccess/managers'

/**
 * DEV-2353 — One-time "Action required" overlay shown immediately after a client sends
 * (or resends) an MCC link request. Tells them they must go into Google Ads and accept
 * the invitation for the link to activate. Not a persisted banner — purely ephemeral UI.
 */
export const MccAcceptInstructionsModal = ({
	open,
	onClose
}: {
	open: boolean
	onClose: () => void
}) => {
	const handleOpenGoogleAds = () => {
		window.open(GOOGLE_ADS_MANAGERS_URL, '_blank', 'noopener,noreferrer')
	}

	return (
		<GDialog open={open} onClose={onClose} title="Action required" maxWidth="lg" showClose>
			<div className="flex flex-col gap-6">
				<p className="text-base text-t-default">
					We&apos;ve sent a request to link your Google Ads account to our Manager
					(MCC) account.
				</p>

				<ol className="flex flex-col gap-4">
					<li className="flex items-start gap-3">
						<span className="flex items-center justify-center w-6 h-6 shrink-0 rounded-full bg-t-step-inactive text-[color:var(--brand-chip-ink,#554BFD)] text-sm font-medium">
							1
						</span>
						<p className="text-base text-t-default pt-0.5">
							Open{' '}
							<span className="font-medium">Google Ads</span> ›{' '}
							<span className="font-medium">Admin</span> ›{' '}
							<span className="font-medium">Access and security</span> ›{' '}
							<span className="font-medium">Managers</span>
						</p>
					</li>
					<li className="flex items-start gap-3">
						<span className="flex items-center justify-center w-6 h-6 shrink-0 rounded-full bg-t-step-inactive text-[color:var(--brand-chip-ink,#554BFD)] text-sm font-medium">
							2
						</span>
						<p className="text-base text-t-default pt-0.5">
							Find the request from{' '}
							<span className="font-medium">ClickGuard</span> and click{' '}
							<span className="font-medium">Accept</span>
						</p>
					</li>
				</ol>

				<div className="flex justify-end">
					<GButton
						variant="contained"
						color="yellow"
						label="Open Google Ads"
						shape="circle"
						size="md"
						onClick={handleOpenGoogleAds}
					/>
				</div>
			</div>
		</GDialog>
	)
}
